var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEq25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1217_5793)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1217_5793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5V67.5Z",
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 27.675C0.5 19.353 3.16975 12.7748 8.4825 7.87531L8.48252 7.8753C13.8197 2.95359 19.9883 0.5 27 0.5C34.0117 0.5 40.1802 2.95355 45.5173 7.87517C50.826 12.7748 53.5 19.3532 53.5 27.675C53.5 33.1679 51.3183 39.185 46.8794 45.7461C42.4947 52.2272 35.8757 59.2569 27 66.8429C18.1243 59.2569 11.5053 52.2272 7.12058 45.7461C2.68166 39.185 0.5 33.1679 0.5 27.675Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 39V36.9474H24.0571V33.3895H23.5482C21.7161 33.3895 20.1667 32.7509 18.9 31.4737C17.6333 30.1965 17 28.6342 17 26.7868C17 25.3956 17.3958 24.1298 18.1875 22.9895C18.9792 21.8491 20.0196 21.0509 21.3089 20.5947C21.3994 19.6825 21.7952 18.9412 22.4964 18.3711C23.1976 17.8009 24.0119 17.55 24.9393 17.6184L24.2268 15.6L25.6179 15.1019L25.1429 13.8211L27.3821 13L27.8571 14.2658L29.2143 13.7868L33.0482 23.8789L31.5893 24.3921L32.0643 25.6579L29.8929 26.4447L29.4179 25.1789L27.9589 25.7263L27.1107 23.4C26.7714 23.7877 26.3699 24.0671 25.9063 24.2382C25.4426 24.4092 24.9468 24.4833 24.4191 24.4605C23.8385 24.4377 23.2994 24.2553 22.8018 23.9132C22.3042 23.5711 21.9083 23.1377 21.6143 22.6132C20.8226 23.0009 20.1949 23.5707 19.7313 24.3225C19.2676 25.0743 19.0357 25.8958 19.0357 26.7868C19.0357 28.0507 19.4744 29.125 20.3519 30.0097C21.2293 30.8945 22.2947 31.3368 23.5482 31.3368H35.3214V33.3895H27.45V36.9474H36V39H17ZM29.0786 23.5368L30.8768 22.8868L28.1625 15.8395L26.3643 16.4895L29.0786 23.5368ZM24.6619 22.75C25.1409 22.75 25.5443 22.5866 25.8723 22.2599C26.2003 21.9332 26.3643 21.5284 26.3643 21.0455C26.3643 20.5625 26.2023 20.1557 25.8783 19.825C25.5543 19.4943 25.1528 19.3289 24.6738 19.3289C24.1948 19.3289 23.7914 19.4923 23.4634 19.819C23.1354 20.1457 22.9714 20.5505 22.9714 21.0335C22.9714 21.5164 23.1334 21.9232 23.4575 22.2539C23.7815 22.5846 24.1829 22.75 24.6619 22.75Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1217_5793",
    x: -4,
    y: 0,
    width: 62,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1217_5793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1217_5793",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1217_5793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEq25);
export default __webpack_public_path__ + "static/media/pin-eq-25.ac4066c0918a25dc87716c85b9c50c50.svg";
export { ForwardRef as ReactComponent };